import React, { useState, useEffect } from "react";
import storyData from "../story.json";
import { motion } from "framer-motion";
import "./TextAdventure.css";

const TextAdventure = () => {
  const [currentNode, setCurrentNode] = useState("start");
  const [isFading, setIsFading] = useState(false);
  const [choices, setChoices] = useState(
    JSON.parse(localStorage.getItem("choices")) || {}
  );
  const [haikuInput, setHaikuInput] = useState("");
  const [isHaikuSubmitted, setIsHaikuSubmitted] = useState(false);

  useEffect(() => {
    setIsHaikuSubmitted(false);
    setHaikuInput(""); // Clear haiku input on reload
  }, []);

  const playSound = () => {
    const audio = new Audio(process.env.PUBLIC_URL + "/luigi-oh-my-god.mp3");
    audio.play();
  };

  const handleOptionClick = (nextNode, choice, saveData) => {
    if (saveData) {
      const { key, value } = saveData;
      const updatedChoices = { ...choices, [key]: value };
      setChoices(updatedChoices);
      localStorage.setItem("choices", JSON.stringify(updatedChoices));
    }

    setIsFading(true);
    setTimeout(() => {
      setCurrentNode(nextNode);
      setIsFading(false);
      setIsHaikuSubmitted(false);
      setHaikuInput("");
    }, 500);
  };

  const handleRestart = () => {
    localStorage.clear();
    setChoices({});
    setHaikuInput("");
    setIsHaikuSubmitted(false);
    setCurrentNode("start");
  };

  const handleHaikuSubmit = (e, nextNode) => {
    e.preventDefault();
    if (haikuInput.trim()) {
      const updatedChoices = { ...choices, haiku: haikuInput };
      setChoices(updatedChoices);
      localStorage.setItem("choices", JSON.stringify(updatedChoices));

      setIsHaikuSubmitted(true);
      setIsFading(true);

      setTimeout(() => {
        setCurrentNode(nextNode);
        setIsFading(false);
        setIsHaikuSubmitted(false);
        setHaikuInput("");
      }, 500);
    }
  };

  const currentStoryNode = storyData[currentNode] || {};
  const { text = "", options = [], conclusion = "", type = "" } = currentStoryNode;

  useEffect(() => {
    if (conclusion && options.length === 0) {
      playSound();
    }
  }, [conclusion, options]);

  useEffect(() => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  }, [currentNode]);
  

  const getPersonalizedDialogue = (text) => {
    return text.split("\n").map((line, index) => {
      const matches = line.match(/{(.*?)}/g);
      if (matches) {
        matches.forEach((match) => {
          const choiceKey = match.replace(/{|}/g, "");
          if (choices[choiceKey]) {
            line = line.replace(match, choices[choiceKey]);
          }
        });
      }
      return <React.Fragment key={index}>{line}<br /></React.Fragment>;
    });
  };

  const haikuOption = options.find((option) => option.is_haiku);

  return (
    <div className={`text-adventure-container ${
        type === "win" ? "win-screen" : type === "lose" ? "lose-screen" : ""
      }`}
    >
      <motion.div className={`text-adventure-text ${isFading ? "fade-out" : "fade-in"}`}
        transition={{ duration: 0.5 }}
      >
        {getPersonalizedDialogue(text)}
      </motion.div>

      <div className="text-adventure-buttons">
        {haikuOption ? (
          <div className="haiku-input-container">
            <p>Write your haiku:</p>
            <form onSubmit={(e) => handleHaikuSubmit(e, haikuOption.next)} className="haiku-form">
              <textarea
                value={haikuInput}
                onChange={(e) => setHaikuInput(e.target.value)}
                className="haiku-textarea"
                placeholder="Write your haiku here..."
                required
              />
              <button type="submit" className="haiku-submit-button">Submit Haiku</button>
            </form>
          </div>
        ) : (
          options.map((option, index) => (
            <motion.button
              key={index}
              onClick={() => handleOptionClick(option.next, option.text, option.save)}
              className="text-adventure-button"
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              style={{ opacity: isFading ? 0 : 1 }}
            >
              {option.text}
            </motion.button>
          ))
        )}

        {options.length === 0 && (
          <motion.button
            onClick={handleRestart}
            className="text-adventure-button restart-button"
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.2 }}
            style={{ opacity: isFading ? 0 : 1 }}
          >
            Restart Story
          </motion.button>
        )}
      </div>
    </div>
  );
};

export default TextAdventure;
